import { render } from "./VulnPublicDetail.vue?vue&type=template&id=6736ccaa"
import script from "./VulnPublicDetail.vue?vue&type=script&lang=js"
export * from "./VulnPublicDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__